mat-radio-group{display:flex;flex-direction:column}.radio-button-row{display:flex;gap:8px}
/*# sourceMappingURL=radio-buttons-output.component.css.map */
